﻿
export class QuoteWizardComponentFrameController {

    public showHelp:boolean;
    
    static $inject = ['$state'];

    constructor(public $state: ng.ui.IStateService) {
        this.showHelp = false;
    }    
}
